const ITEMS = [
  "Strategic Marketing",
  "Branding & Logo Design",
  "Social Media Management",
  "Content Creation",
  "Graphic Design",
  "Marketing Campaigns",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#E5E0D8] bg-[#FBF9F6] overflow-hidden py-10 md:py-14"
      aria-label="Services ribbon"
    >
      <div className="wj-marquee-track flex whitespace-nowrap will-change-transform">
        {loop.map((item, i) => (
          <div
            key={`${item}-${i}`}
            className="flex items-center gap-24 md:gap-32 pr-24 md:pr-32"
          >
            <span className="font-serif-display text-4xl md:text-6xl lg:text-7xl text-[#1C1B1A] leading-none">
              {item}
            </span>
            <span className="text-[#B4A087] text-3xl md:text-5xl leading-none">
              ✦
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
